/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { RegionsGetResponse } from '../models/RegionsGetResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class RegionsService {
    /**
     * @param includeSuggestion
     * @returns RegionsGetResponse OK
     * @throws ApiError
     */
    public static get(
        includeSuggestion: boolean = false,
    ): CancelablePromise<RegionsGetResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Regions',
            query: {
                'includeSuggestion': includeSuggestion,
            },
        });
    }
}
